import TipTapEditor from "../../editor/TipTapEditor";

const AdminDocumentEditorPage = () => {
  return <TipTapEditor />;
};

export default AdminDocumentEditorPage;
